import Vue from 'vue'
import Element from 'element-ui'
import '../assets/css/element-theme.scss'
import '../assets/css/element-reset.scss'
Vue.use(Element)
